import styled from 'styled-components';
import CancelSvg from '../../assets/mytrips/cancel.svg';

const CancelIcon = styled(CancelSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default CancelIcon;
